import {Component, Inject, OnInit} from '@angular/core';
import {UIStateEnum} from "../../../enum/UIStateEnum";
import {IFailedAuditEvent} from "../../../interfaces/audit/IFailedAuditEvent";
import {AuditingService} from "../../../services/auditing.service";
import {ErrorHandlingService} from "../../../services/error-handling.service";
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {DialogBaseComponent} from "../dialog-base/dialog-base.component";
import {PipesModule} from "../../../pipes/pipes.module";
import {DatePipe} from "@angular/common";
import {FormatterComponent} from "../../json-formatter/json-formatter.component";

@Component({
  selector: 'app-failed-audit-detail',
  templateUrl: './failed-audit-detail.component.html',
  standalone: true,
  imports: [
    DialogBaseComponent,
    PipesModule,
    DatePipe,
    FormatterComponent
  ],
  styleUrls: ['./failed-audit-detail.component.scss']
})
export class FailedAuditDetailComponent implements OnInit {

  public uiState: UIStateEnum = UIStateEnum.ShowData;
  public uiStateEnumForTemplate = UIStateEnum;
  public parsedData: any;
  public command: any;
  public result: any;
  public errorTypes: number[] = [];
  public exception: string | null = null;

  constructor(@Inject(MAT_DIALOG_DATA) public data: {
                audit: IFailedAuditEvent
              },
              private errorHandlingService: ErrorHandlingService,
              private auditingService: AuditingService) {
  }

  ngOnInit(): void {
    this.parseAuditData();
  }

  private parseAuditData(): void {
    try {
      this.parsedData = JSON.parse(this.data.audit.Data);
      this.command = this.parsedData?.Command;
      this.result = this.parsedData?.Result;

      // ErrorType is a single integer in the backend, convert to array for display
      const errorType = this.result?.ErrorType;
      this.errorTypes = errorType && errorType !== 0 ? [errorType] : [];

      this.exception = this.result?.Exception || null;
    } catch (e) {
      this.parsedData = this.data.audit.Data;
    }
  }

  getErrorTypeName(errorTypeValue: number): string {
    return this.auditingService.getErrorTypeName(errorTypeValue);
  }
}
